<template>
<div>
  <div
    style="border: 1px solid rgba(0,0,0,0.2); padding: 15px; border-radius: 15px; position: relative"
    class="mb-4"
    v-if="$rc.$state.isAuthActorSystemAdmin()"
  >
    <p><b>Manage Feature Access</b></p>

    <m-list-buttons
        :items="feature_access_button_items"
    />
    
  </div>

  <div
    style="border: 1px solid rgba(0,0,0,0.2); padding: 15px; border-radius: 15px; position: relative"
    v-if="$rc.$state.isAuthActorSystemAdmin()"
  >
    <p><b>Actions</b></p>

    <m-list-buttons
        :items="action_button_items"
    />

    <m-autocomplete-organization
          label="Assign to Organization"
          dialog_only
          ref="search-orgs"
          v-on:input="doSwitchOrg"
      />

      <m-welcome-screen-settings-dialog
        ref="settings-dialog"
        v-on:ok="$emit('reload')"
      />
    
  </div>
</div>
</template>

<script>
const E164 = require('@/js/E164.js');

export default {
    props: {
        profile: {
            type: Object,
            default: function() { return {}; }
        },
    },

    data() {
      
      return {

        action_button_items: [
            { 'title': 'Welcome screen', 'sub_title': 'Access the welcome screen for this organization', 'icon': 'mdi-human-greeting', 'action': this.onClickWelcomeScreen },
            { 'title': 'Provision', 'sub_title': 'Access the provision screen for another organization', 'icon': 'mdi-cloud-search-outline', 'action': this.onClickProvisionSearch },
            { 'title': 'Welcome screen settings', 'sub_title': 'Customize the welcome screen for this organization (sections that show etc.)', 'icon': 'mdi-cog-outline', 'action': this.onClickWelcomeScreenSettings },
            { 'title': 'Organization settings', 'sub_title': 'View or edit the settings for this organization', 'icon': 'mdi-domain', 'action': this.onClickOrganizationSettings },
        ],

      }
    },
    
    methods: {

      onClickWelcomeScreenSettings()
      {
        this.$refs['settings-dialog'].showDialog(this.profile);
      },

      onClickViewNotes()
      {
        this.$refs['view-notes-dialog'].showDialog(this.profile.organization_account.organization_id);
      },

      onClickActivateOrganization()
      {
        this.$rc.confirm({
          'title': 'Activate Organization',
          'body': 'Are you sure that you would like to move '+this.profile.organization_account.label+' from the pre-launch to the active state?',
          'btn_text_ok': 'Activate',
          'btn_text_cancel': 'Cancel',
          'on_ok': () => {
            this.doActivateOrganization();
          },
        });
      },

      onClickProvisionSearch()
      {
        this.$refs['search-orgs'].showDialog();
      },

      doSwitchOrg(new_organization_id)
      {
          this.$router.push({
            'name': 'provision',
            'params' : {
                'organization_id': new_organization_id,
            }
          });
      },

      onClickWelcomeScreen()
      {
        let any_org_admin = this.profile.employees.find((item) => item.is_organization_admin);
        if ( any_org_admin == null )
        {
            this.$rc.alert('No Organization Admin', 'The organization does not have an organization administrator yet.<br/><br/>You need to create an organization admin before you can access the welcoem screen');
            return;
        }

        this.$router.push({
            'name': 'welcome_ordinary_user',
            'params' : {
                'employee_id': any_org_admin.employee_id,
            },
        });
      },

      onClickOrganizationSettings()
      {
        window.open(this.$router.resolve({
          'name': 'settings-organization',
          'params' : {
            'organization_id': this.profile.organization_account.organization_id,
          }
        }).href, '_blank');
      },

      doActivateOrganization()
      {
          this.$rc.rest({
                'spinner': false,
                'endpoint': 'PATCH: /api/v1/organizations/organization-account',
            
                'params' : {
                    'organization_id': this.profile.organization_account.organization_id,
                    'organization_state': 'active',
                    },
            
                'on_success': (data) => {
                        this.$router.push({
                          'name': 'home',
                        });
                    },
            
                'on_error': 'Unable to change organization state.',
            });
      },

      onSwitchEndpoint(endpoint)
      {
        this.$router.replace({
              'name': 'home-routed',
              'params' : {
                  'endpoint': E164.slimEndpoint(endpoint),
                  'conversation_id': 'none',
              }
          })
          .catch(e=>{});
      },

      onDisableSendingBulkMessages()
      {
        this.$rc.prompt({
            'title' : 'Disable Sending Bulk Messages',
            'label' : 'Message to show to the organization',
            'value' : 'Sending bulk messages has been disabled for your organization. Please contact RedChirp customer support to re-enable.',
            'after_prompt' : (value) => {

                if ( value.length < 3 )
                {
                    this.$rc.alert('Too short', 'Enter at least three characters');
                    return;
                }

                this.profile.provision_info.bulk_message_send_disabled_message = value;
                this.doPatch();

                return;
            }
        });
      },

      onEnableSendingBulkMessages()
      {
        this.profile.provision_info.bulk_message_send_disabled_message = null;
        this.doPatch();
      },

      doPatch()
      {
        this.$rc.rest({
            'spinner': true,
            'endpoint': 'PUT: /api/v1/provision/provision-info',
        
            'params' : this.profile.provision_info,
        
            'on_success': (data) => {
                    this.$emit('reload');
                },
        
            'on_error': 'Unable to update provision',
        });
      },

    },

    computed: {
      can_send_bulk_messages()
      {
        return this.profile.provision_info.bulk_message_send_disabled_message == null;
      },

      feature_access_button_items()
      {
        return [
            {
              'title': (this.can_send_bulk_messages ? 'Disable' : 'Re-Enable') + ' Sending Bulk Messages',
              'sub_title': (this.can_send_bulk_messages ? '' : 'Message: "' + this.profile.provision_info.bulk_message_send_disabled_message + '"'),
              'icon': 'mdi-comment-text-multiple',
              'action': this.can_send_bulk_messages ? this.onDisableSendingBulkMessages : this.onEnableSendingBulkMessages
            },
        ];
      },

    }
}
</script>

<style lang="scss" scoped>

</style>